import React, { createContext, useState, useEffect } from 'react';

// Create the LayoutContext
export const LayoutContext = createContext();

const LayoutProvider = ({ children }) => {
    const [layoutConfig, setLayoutConfig] = useState({
        ripple: false,
        inputStyle: 'outlined',
        menuMode: 'static',
        colorScheme: 'light',
        theme: 'lara-light-indigo',
        scale: 14 // Default scale
    });

    // Dynamically apply the scale to the document's font size
    useEffect(() => {
        document.documentElement.style.fontSize = `${layoutConfig.scale}px`;
    }, [layoutConfig.scale]);

    const [layoutState, setLayoutState] = useState({
        staticMenuDesktopInactive: false,
        overlayMenuActive: false,
        profileSidebarVisible: false,
        configSidebarVisible: false,
        staticMenuMobileActive: false,
        menuHoverActive: false
    });

    return (
        <LayoutContext.Provider value={{ layoutConfig, setLayoutConfig, layoutState, setLayoutState }}>
            {children}
        </LayoutContext.Provider>
    );
};

export default LayoutProvider;
